import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-schedule-update-modal',
  templateUrl: './schedule-update-modal.component.html',
  styleUrls: ['./schedule-update-modal.component.css']
})
export class ScheduleUpdateModalComponent implements OnInit {
  @Output() callOnPositiveBtnClick: EventEmitter<string> = new EventEmitter();
  @Output() callOnNegativeBtnClick: EventEmitter<string> = new EventEmitter();
  @Input() modalTitle: string;
  @Input() count: number;
  @Output() timeschedule = new EventEmitter();
  @Output() dateschedule = new EventEmitter();

  rootScopeData: RootScopeDeclare;
  isRtl: boolean;
  time: string;
  date: NgbDateStruct;

  isToday: boolean = false;


  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit() {
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }
  getCurrentTime(time: string) {
    this.time = time;
  }

  getCurrentDate(date: NgbDateStruct) {
    this.date = date;
    const _today = new Date();
    if (
      _today.getFullYear() == date.year && 
      _today.getMonth() + 1 == date.month && 
      date.day == _today.getDate()) {
      this.isToday = true;
    } else {
      this.isToday = false;
    }

  }

  onNegativeButtonClick(): void {
    this.callOnNegativeBtnClick.emit();
  }

  onPositiveButtonClick(): void {
    if (this.time === undefined) {
      const now = new Date();
      this.time = ('0' + now.getHours()).slice(-2) + ':' + ('0' + now.getMinutes()).slice(-2);
    }


    //
    let time = this.time.split(":");
    let UTCDate = new Date(`${this.date.month}/${this.date.day}/${this.date.year} ${time[0]}:${time[1]}:00`);//"6/23/2020 15:48:00"
    this.timeschedule.emit(`${UTCDate.getUTCHours()}:${UTCDate.getUTCMinutes()}`);
    this.dateschedule.emit(`${UTCDate.getUTCMonth() + 1}/${UTCDate.getUTCDate()}/${UTCDate.getUTCFullYear()}`);
    this.callOnPositiveBtnClick.emit();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }

}
